import { render, staticRenderFns } from "./PensionPagination.vue?vue&type=template&id=888e0f2e&"
import script from "./PensionPagination.vue?vue&type=script&lang=js&"
export * from "./PensionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports